<template>
  <div class="service-terms">
    <xl-tabs class="info-tabs" v-model="activeTab" :tabLists="tabList">
      <!-- 隐私政策 -->
      <template #privacyPolicy>
        <xl-scrollbar>
          <div class="main-box" v-html="privacyPolicyHtml"></div>
        </xl-scrollbar>
      </template>
      <!-- 使用协议 -->
      <template #agreement>
        <xl-scrollbar>
          <!-- v-html="agreementHtml -->
          <div class="main-box" v-html="agreementHtml"></div>
        </xl-scrollbar>
      </template>
      <!-- BAA -->
      <!-- <template #BAA>
        <xl-scrollbar>
          <div v-html="BAAHtml"></div>
        </xl-scrollbar>
      </template> -->
    </xl-tabs>
  </div>
</template>

<script setup>
  import { XlTabs, XlScrollbar } from "@shining3d/ui-components";
  import { ref, onMounted } from 'vue';
  import { useLang } from '@shining3d/common-module/utils/lang.js';
  import serviceTermsApi from "../../api/serviceTerms"
  import { langMap } from '../../common/enum';
  import { VueCookieNext } from 'vue-cookie-next';
  const lang = ref( VueCookieNext.getCookie( 'lang' ));
  const { $t } = useLang( '@shining3d/xl-design-order' );

  const activeTab = ref('privacyPolicy');
  const tabList = [
    { label: $t('design.serviceTerms.privacyPolicy') || '隐私政策', name: "privacyPolicy", lazy: true },
    { label: $t('design.serviceTerms.agreement') || '使用协议', name: "agreement", lazy: true },
    // { label: "BAA", name: "BAA", lazy: true }
  ];
  // 隐藏政策
  const privacyPolicyHtml = ref('')
  // const privacyPolicyHtml1 = ref('');
  // 使用协议
  const agreementHtml = ref( '' );
  const BAAHtml = ref( 'BAA-test' );
  // const privacyHeaderHtml1 = ref('\u003ch1 style=\u0022text-align: center;\u0022\u003e隐私政策\u003c/h1\u003e');
  onMounted(()=> {
    // privacyPolicyHtml.value = privacyHeaderHtml1.value.concat(privacyPolicyHtml1.value);
    const params = {
        lang: langMap.get(lang.value), 
        associatedSystem: 'dentalx', 
        nameCodes: ['privacy', 'termsOfUse']
    }
    serviceTermsApi.checkComplianceVersion( params ).then(res => {
        if( res && res.status === 'success'){
            res?.result?.contents?.forEach((item) => {
                if( item?.nameCode === 'privacy'){
                    privacyPolicyHtml.value = item.content;
                } else if(item?.nameCode === 'termsOfUse') {
                    agreementHtml.value = item.content;
                }
            })
        }
    })
  })
</script>

<style lang="scss" scoped>
.service-terms {
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #ffffff;
  overflow: hidden;
  :deep(.xl-tabs .el-tabs__nav-wrap) {
    padding-left: 0 !important;
  }
  :deep(.xl-tabs .el-tabs__content) {
    padding: 0 !important;
    font-family: "Alibaba PuHuiTi 2.0";
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    // color: #737e99;
    overflow: scroll;
    max-height: calc(100vh - 58px);
  }
  :deep(.el-scrollbar__wrap) {
    height: calc(100vh - 148px);
  }
  .main-box{
    width: 100%;
    padding: 0 88px !important;
    box-sizing: border-box;
    overflow-x: hidden;
  }
}
</style>